import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "refreshing", false);
    _defineProperty(_this, "notificationText", 'New content is available!');
    _defineProperty(_this, "refreshButtonText", 'Refresh');
    _defineProperty(_this, "registration", null);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      var _this2 = this;
      // Listen for swUpdated event and display refresh notification as required.
      document.addEventListener('swUpdated', this.showRefreshUI, {
        once: true
      });
      // Refresh all open app tabs when a new service worker is installed.
      navigator.serviceWorker.addEventListener('controllerchange', function () {
        if (_this2.refreshing) return;
        _this2.refreshing = true;
        window.location.reload();
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Avoid warning for missing template
    }
  }, {
    key: "showRefreshUI",
    value: function showRefreshUI(e) {
      var _this3 = this;
      // Display a notification inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      var h = this.$createElement;
      this.registration = e.detail;
      this.$notify.info({
        title: 'Update available',
        message: h('div', {
          class: 'sw-update-popup'
        }, [this.notificationText, h('br'), h('button', {
          on: {
            click: function click(e) {
              e.preventDefault();
              _this3.refreshApp();
            }
          }
        }, this.refreshButtonText)]),
        position: 'bottom-right',
        duration: 0
      });
    }
  }, {
    key: "refreshApp",
    value: function refreshApp() {
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) return;
      this.registration.waiting.postMessage('skipWaiting');
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'ServiceWorkerUpdatePopup'
})], default_1);
export default default_1;